export default __webpack_public_path__ + "static/media/ic-small-check-xs.8cfd5064.svg";